export default __webpack_public_path__ + "static/media/ic-subtract.1967bfea.svg";